export default __webpack_public_path__ + "static/media/ar1.5a4beaa8.jpg";